// An archived meeting's Transcript tab, in the same view as the live meeting (Kyle, Oct 28): the live
// room that recorded it, with its AI notes and their buttons; or, for older and uploaded meetings, the
// stored transcript in the same look (no notes). Text that isn't a transcript shows as it was.
import { useEffect, useState, type ReactNode } from "react";
import { DOCS_API_DOMAIN } from "@launchos/shared-utils/env";
import { LiveRoom } from "./screens/LiveRoom";
import { parseArchivedTranscript } from "./liveRoom";

interface Meeting { id: string; title: string; date?: string | null; transcript?: string | null }

export function ArchivedTranscript({ meeting, fallback }: { meeting: Meeting; fallback?: ReactNode }) {
  const [liveId, setLiveId] = useState<string | null | undefined>(undefined); // undefined = still looking

  useEffect(() => {
    let live = true;
    setLiveId(undefined);
    fetch(`${DOCS_API_DOMAIN}/api/agents/live-for-meeting/${encodeURIComponent(meeting.id)}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => live && setLiveId((d && d.id) || null))
      .catch(() => live && setLiveId(null));
    return () => {
      live = false;
    };
  }, [meeting.id]);

  if (liveId === undefined) return null;
  if (liveId) return <LiveRoom roomId={liveId} embedded />;
  const lines = parseArchivedTranscript(meeting.transcript || "");
  if (lines.length) return <LiveRoom embedded staticRoom={{ title: meeting.title, startedAt: meeting.date, lines }} />;
  return <>{fallback ?? <div className="whitespace-pre-wrap p-6 text-sm">{meeting.transcript}</div>}</>;
}
